import useTranslation from '@/utils/hooks/translation/useTranslation';

type FallbackProps = {
    resetErrorBoundary: () => void;
};

const DataNotificationsErrorFallback = ({ resetErrorBoundary }: FallbackProps) => {
    const { t } = useTranslation();
    return (
        <div
            role="alert"
            className="flex flex-1 flex-col items-center justify-center space-y-3 p-8">
            <p className="text-center">{t('errors:error_occured_fetch_data')}</p>
            <button className="text-icoBlue underline" onClick={resetErrorBoundary}>
                {t('commons:try_again')}
            </button>
        </div>
    );
};

export default DataNotificationsErrorFallback;
